import styled from 'styled-components';
import { FlexCol } from 'components/primitives/flex';
import { mediaMMdMax } from 'helpers/breakpoints';

export const InputWrap = styled.div<{ noBorder: boolean }>`
  border-bottom: ${({ noBorder }) => (noBorder ? 'unset' : '1px solid rgba(219, 223, 229, 0.5)')};
`;

export const MessageError = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #bc350a;
  max-width: 340px;
`;

export const PricingSection = styled(FlexCol)`
  padding-top: 30px;
`;

export const Fees = styled.div`
  color: #434c5c;
  font-size: 12px;
  font-weight: initial;
  ${mediaMMdMax} {
    padding-top: 5px;
  }
`;

export const ButtonContainer = styled.div`
  ${mediaMMdMax} {
    position: fixed;
    z-index: 1;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0px 0px 20px 0px #0000001a;
    padding: 22px 24px;
    background-color: #fff;
  }
`;

export interface TripTime {
  label: string;
  value: string;
}

// errors here is a simplified interface for react-hook-form errors from the parent component.
export interface SimplifiedRHFErrors {
  trip_start?: { message: string };
}
